import React, { useState } from "react";
import { ErrorMessage, Formik } from "formik";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Snackbar from "@mui/material/Snackbar";
import { NavLink, useNavigate } from "react-router-dom";
import LockOpenRoundedIcon from "@mui/icons-material/LockOpenRounded";
import config from "../config/Config";
import InputAdornment from "@mui/material/InputAdornment";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import "../styles/authStyles/forgotPassword.css";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export default function ResetPassword() {
  const [open, setOpen] = useState(true);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const navigate = useNavigate();
  const [detail, setDetail] = useState("");
  const [severityType, setSeverityType] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const vertical = "top";
  const horizontal = "center";
  const initialValues = {
    new_password: "",
    confirm_password: "",
    token: "",
    email: "",
  };

  const handleClose = () => {
    setOpen(false);
    navigate("/");
  };

  const handleClose1 = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  const onSubmit = (values) => {
    if (values.new_password !== values.confirm_password) {
    }
    var tokenStr = localStorage.getItem("access_token");
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    const email = urlParams.get("email");
    setIsLoading(true);
    fetch(`${config.baseUrl}reset-password/`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: token,
        email: email,
        new_password: values.new_password,
        confirm_password: values.confirm_password,
      }),
    }).then(async (response) => {
      const results = await response.json();
      if (response.status === 200) {
        setDetail(results.message);
        setSeverityType("success");
        setOpenSnackbar(true);
        await sleep(2000);
        setIsLoading(false);
        navigate("/");
      } else {
        setDetail(results.detail);
        setSeverityType("error");
        setOpenSnackbar(true);
        setIsLoading(false);
      }
    });
  };

  const validate = (values) => {
    let errors = {};

    if (!values.new_password) {
      errors.new_password = "Please enter new password";
    } else if (values.new_password.length <= 6) {
      errors.new_password = "Must be more than 6 characters";
    }

    if (!values.confirm_password) {
      errors.confirm_password = "Please enter confirm password";
    } else if (values.confirm_password.length <= 6) {
      errors.confirm_password = "Must be more than 6 characters";
    }
    return errors;
  };

  const handleDialogClose = (event, reason) => {
    if (reason !== "backdropClick") {
      handleClose();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
    }
  };

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  const handleEnd = () => {
    localStorage.clear();
    navigate("/");
  };

  const handleClickNew = () => {
    setShowNewPassword((prev) => !prev);
  };

  const handleClickConfirm = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  return (
    <Dialog
      onClose={handleDialogClose}
      aria-labelledby="customized-dialog-title"
      disableEscapeKeyDown={true}
      open={open}
      className="bgimage"
      hideBackdrop={false}
    >
      <div className="forgot-modal-dialog-title">
        <DialogTitle
          sx={{ m: 0, py: "3px", width: "100%" }}
          id="customized-dialog-title"
        >
          Reset Password
        </DialogTitle>
        <CancelOutlinedIcon
          aria-label="close"
          onClick={handleClose}
          sx={{
            color: "white",
            fontSize: "28x",
            cursor: "pointer",
          }}
        />
      </div>
      <DialogContent dividers className="password-modal-body">
        <Formik
          initialValues={initialValues}
          validate={validate}
          onSubmit={onSubmit}
        >
          {({
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit}>
              <Typography variant="h6" gutterBottom className="forgot-bold">
                <TextField
                  margin="normal"
                  fullWidth
                  id="new_password"
                  name="new_password"
                  type={showNewPassword ? "text" : "password"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.new_password}
                  onKeyDown={handleKeyDown}
                  autoComplete="off"
                  placeholder="New Password"
                  style={{ color: "black" }}
                  variant="standard"
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockOpenRoundedIcon className="forgot-icons"/>
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={handleClickNew} edge="end">
                            {showNewPassword ? (
                              <Visibility  className="forgot-icons"/>
                            ) : (
                              <VisibilityOff  className="forgot-icons"/>
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    },
                  }}
                />
                <ErrorMessage
                  name="new_password"
                  component="div"
                  className="error"
                />
                <TextField
                  margin="normal"
                  fullWidth
                  id="confirm_password"
                  name="confirm_password"
                  type={showConfirmPassword ? "text" : "password"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.confirm_password}
                  autoComplete="off"
                  onKeyDown={handleKeyDown}
                  placeholder="Confirm Password"
                  style={{ color: "black" }}
                  variant="standard"
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockOpenRoundedIcon className="forgot-icons"/>
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={handleClickConfirm} edge="end">
                            {showConfirmPassword ? (
                              <Visibility className="forgot-icons" />
                            ) : (
                              <VisibilityOff className="forgot-icons" />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    },
                  }}
                />
                <ErrorMessage
                  name="confirm_password"
                  component="div"
                  className="error"
                />
                <Grid container spacing={2} className="form-layout-btn">
                  <Button
                    className="primary-btn"
                    type="submit"
                    variant="contained"
                    disabled={isLoading === true}
                  >
                    {isLoading === false ? (
                      "Submit"
                    ) : (
                      <CircularProgress
                        className="circular_spiner"
                        size={24}
                        sx={{ color: "white" }}
                      />
                    )}
                  </Button>
                  <NavLink
                    style={{ textDecoration: "none", color: "#067DE2" }}
                    exact
                    to="/"
                  >
                    <Button className="primary-btn-cancel" variant="outlined">
                      Cancel
                    </Button>
                  </NavLink>
                </Grid>
              </Typography>
            </form>
          )}
        </Formik>
      </DialogContent>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleClose1}
        onEnded={handleEnd}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Alert elevation={6} variant="filled" onClose={handleClose1} severity={severityType}>
          <div className="error" style={{ color: "white" }}>
            <span>{detail}</span>
          </div>
        </Alert>
      </Snackbar>
    </Dialog>
  );
}
